var map = {
	"./gallery - potions_00.jpg": 1298,
	"./gallery - potions_01.jpg": 1299,
	"./gallery - potions_02.jpg": 1300,
	"./gallery - potions_03.jpg": 1301,
	"./gallery - potions_04.jpg": 1302,
	"./gallery - potions_05.jpg": 1303,
	"./gallery - potions_06.jpg": 1304,
	"./gallery - potions_07.jpg": 1305,
	"./gallery - potions_08.jpg": 1306,
	"./gallery - potions_09.jpg": 1307,
	"./gallery - potions_10.jpg": 1308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1297;